import React from 'react';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { Button, Grid, Paper } from '@material-ui/core';
import ViewIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/DeleteForever';

const PredictionsFilterByDate = ({
  classes,
  loading,
  fromDate,
  toDate,
  totalSamplesWithinDates,
  totalLabelsWithinDates,
  onDelete,
  handleDateChange,
  onViewSamples,
  onRelabelSamples,
}) => {
  return (
    <Paper className={classes.paper}>
      <Grid className={classes.bold} container justifyContent="center">
        Filter by date:
      </Grid>
      <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
        <Grid container justifyContent="space-around" alignItems="center">
          <KeyboardDatePicker
            variant="inline"
            format="DD/MM/yyyy"
            margin="normal"
            id="date-picker-inline"
            label="Samples from:"
            value={fromDate}
            maxDate={toDate}
            onChange={(date) => handleDateChange(date, true)}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
          <KeyboardDatePicker
            variant="inline"
            format="DD/MM/yyyy"
            margin="normal"
            id="date-picker-inline2"
            label="Samples to:"
            value={toDate}
            minDate={fromDate}
            onChange={(date) => handleDateChange(date, false)}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
        </Grid>
        <Grid className={classes.labelWithValue}>
          Samples:
          <span className={classes.number}>{totalSamplesWithinDates}</span>
        </Grid>
        <Grid className={classes.labelWithValue}>
          Labels:
          <span className={classes.number}>{totalLabelsWithinDates}</span>
        </Grid>
        <Grid container justifyContent="center" alignItems="center" spacing={2}>
          <Grid item>
            <Button
              size="large"
              disabled={loading}
              className={classes.blueButton}
              variant="contained"
              endIcon={<ViewIcon />}
              disableElevation
              onClick={onViewSamples}
            >
              View
            </Button>
          </Grid>
          <Grid item>
            <Button
              size="large"
              disabled={loading}
              className={classes.darkBlueButton}
              variant="contained"
              endIcon={<EditIcon />}
              disableElevation
              onClick={onRelabelSamples}
            >
              Re-Label
            </Button>
          </Grid>
          <Grid item>
            <Button
              size="large"
              disabled={loading}
              className={classes.redButton}
              variant="contained"
              endIcon={<DeleteIcon />}
              disableElevation
              onClick={onDelete}
            >
              Delete
            </Button>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </Paper>
  );
};

export default PredictionsFilterByDate;
